import { render, staticRenderFns } from "./InputMoney.vue?vue&type=template&id=52646066&scoped=true"
import script from "./InputMoney.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputMoney.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InputMoney.vue?vue&type=style&index=0&id=52646066&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52646066",
  null
  
)

export default component.exports